import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';

const template = styled.tr`
  ${({ theme }) => css`
    color: #E3E3E3;

    cursor: pointer;

    &:hover {
      background: ${`${theme?.colour?.primary}0D`};
    }

    th {
      border-top: 1px solid #E3E3E3;
      border-bottom: 1px solid #E3E3E3;
    }
    td {
      border-top: 1px solid #E3E3E3;
      border-bottom: 1px solid #E3E3E3;
      height: 63px;
    }
  `}
`;

export default Wrapper(template)
